// extracted by mini-css-extract-plugin
export default {"container":"LB-z","brandName":"MB-z","productName":"NB-z","aboveGalleryInfo":"OB-z","belowGalleryInfo":"PB-z","breakLongProductName":"QB-z"};